module.exports = __webpack_public_path__ + "img/cyber.8a229a62.svg";